import React from 'react';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { G300, R400, N500, Y200 } from '@atlaskit/theme/colors';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import InfoIcon from '@atlaskit/icon/glyph/info';

export type NotificationFlagType = 'error' | 'info' | 'normal' | 'success' | 'warning';

interface NotificationProps {
  header: React.ReactNode;
  type?: NotificationFlagType;
  message?: React.ReactNode;
  id: string;
  onCloseClick?: (id: string) => void;
}

export const NotificationFlag: React.FC<NotificationProps> = ({
  header,
  type = 'normal',
  message,
  id,
  onCloseClick,
}: NotificationProps): React.ReactElement | null => {
  const [isMounted, setMounted] = React.useState<boolean>(true);

  const iconMap = new Map<string, React.ReactNode>([
    ['success', <SuccessIcon key={'success'} primaryColor={G300} label="Success" size="medium" />],
    ['error', <ErrorIcon key={'error'} label="Error" primaryColor={R400} />],
    ['warning', <WarningIcon key={'warning'} label="Warning" primaryColor={Y200} />],
    ['info', <InfoIcon key={'info'} label="Info" primaryColor={N500} />],
    ['normal', <SuccessIcon key={'normal'} label="Success" size="medium" />],
  ]);

  return isMounted ? (
    <FlagGroup
      onDismissed={() => {
        onCloseClick?.(id);
        setMounted(false);
      }}
    >
      <AutoDismissFlag id={id} icon={iconMap.get(type)} key={id} title={header} description={message} />
    </FlagGroup>
  ) : null;
};
